<h1 class="container-heading">Transactions List by Box</h1>
<mat-card>
    <common-table2 *ngIf="boxTransactionsTable" [settings]="boxTransactionsTable"></common-table2>
</mat-card>
